class MulticolumnSlider {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.swiper = null;
    this.scrollbarElements = null;
    this.swiperConfig = this.getSwiperConfig();
    
    this.init();
  }

  getSwiperConfig() {
    return {
      slidesPerView: "auto",
      loop: window.innerWidth < 640,
      navigation: {
        nextEl: `.swiper--${this.sectionId} .multicolumn-button--next`,
        prevEl: `.swiper--${this.sectionId} .multicolumn-button--prev`
      },
      on: {
        init: (swiper) => this.onSwiperInit(swiper),
        slideChange: (swiper) => this.onSlideChange(swiper)
      }
    };
  }

  init() {
    this.scrollbarElements = document.querySelectorAll(`.swiper--${this.sectionId} .multicolumn__progress-element`);
    const swiperInstance = new Swiper(`.swiper--${this.sectionId}`, this.swiperConfig);
  }

  onSwiperInit(swiper) {
    this.swiper = swiper;
    this.bindScrollbarEvents();
    const initialRealIndex = this.getRealIndex(swiper.realIndex, this.scrollbarElements.length);
    this.updateActiveScrollbarElement(initialRealIndex);
  }

  onSlideChange(swiper) {
    const realIndex = swiper.params.loop ? 
      swiper.realIndex % this.scrollbarElements.length : 
      swiper.activeIndex;
    
    this.updateActiveScrollbarElement(realIndex);
  }

  getRealIndex(swiperIndex, totalSlides) {
    return this.swiper && this.swiper.params.loop ? swiperIndex % totalSlides : swiperIndex;
  }

  updateActiveScrollbarElement(activeIndex) {
    this.scrollbarElements.forEach((el, index) => {
      el.classList.remove('active');
      if (index === activeIndex) {
        el.classList.add('active');
      }
    });
  }

  bindScrollbarEvents() {
    this.scrollbarElements.forEach((element, index) => {
      element.addEventListener('click', () => {
        this.scrollbarElements.forEach(el => el.classList.remove('active'));
        element.classList.add('active');
        
        if (this.swiper && this.swiper.params.loop) {
          this.swiper.slideToLoop(index);
        } else if (this.swiper) {
          this.swiper.slideTo(index);
        }
      });
    });
  }

  slideTo(index) {
    if (this.swiper && this.swiper.params.loop) {
      this.swiper.slideToLoop(index);
    } else if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }

  slideNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  slidePrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }

  static init(sectionId) {
    return new MulticolumnSlider(sectionId);
  }
}

window.initMulticolumnSlider = function(sectionId) {
  return MulticolumnSlider.init(sectionId);
};
